import { sinceIntervals } from "./schema";
import { notNullOrEmpty } from "../utils";
const processCondition = (condition, interval)=>{
    if (condition.type === "group") {
        return condition.conditions.flatMap((c)=>processCondition(c, interval));
    }
    if (!condition.lhs.value.startsWith("device.") && !condition.lhs.value.startsWith("device[")) {
        return [];
    }
    // Find all the matches
    const regex = new RegExp(`device(\\.${interval.toLowerCase()}Since_(?<eventName>.*?)$|\\[(\\'|\\")${interval.toLowerCase()}Since_(?<eventName2>.*?)(\\'|\\")\\])`, "g");
    const matches = Array.from(condition.lhs.value.matchAll(regex));
    return matches.flatMap((m)=>m.groups?.eventName || m.groups?.eventName2).filter(notNullOrEmpty).map((eventName)=>({
            type: `${interval}_SINCE`,
            event_name: eventName
        }));
};
export const buildComputedPropertiesFromRule = (ruleConditions)=>{
    return sinceIntervals.flatMap((interval)=>ruleConditions.conditions.flatMap((condition)=>processCondition(condition, interval)));
};
